import { useEffect, useState, useCallback } from 'react'

import { setUser } from 'store/authReducer'
import store from 'store/store'
import { hasAccessToken } from 'utils/authToken'
import { establishSession } from 'utils/authSession'

/** Tránh gọi establishSession trùng (Strict Mode / mount kép). */
let verificationPromise = null

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const verifyAuth = useCallback(async () => {
    const finish = (authenticated) => {
      setIsAuthenticated(authenticated)
      setIsLoading(false)
    }

    const existingUser = store.getState().auth?.user
    if (existingUser) {
      finish(true)
      return
    }

    if (!hasAccessToken()) {
      finish(false)
      return
    }

    if (verificationPromise) {
      try {
        await verificationPromise
        finish(Boolean(store.getState().auth?.user))
      } catch {
        finish(false)
      }
      return
    }

    verificationPromise = (async () => {
      try {
        await establishSession(store.dispatch)
        setIsAuthenticated(true)
      } catch (error) {
        console.error('Authentication failed:', error)
        store.dispatch(setUser(null))
        verificationPromise = null
        setIsAuthenticated(false)
      } finally {
        setIsLoading(false)
      }
    })()

    await verificationPromise
  }, [])

  useEffect(() => {
    verifyAuth()
  }, [verifyAuth])

  return { isAuthenticated, isLoading }
}

export { useAuth }
